
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../core';
import { AtividadeFilter } from '../filter';
import { AtividadeTipoSearchTotal } from '../tipo';

@Injectable({
    providedIn: 'root'
})
export class AtividadeTipoHttpService {
    resource = 'atividade';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}/0/tipo`;
    }

    /** Obtem os totais das atividades por tipo */
    getTotais(filter: AtividadeFilter): Observable<AtividadeTipoSearchTotal> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AtividadeTipoSearchTotal>(`${this.pathApi}/total`, {params});
    }
}
